
import RegionToolbar from "@/components/layout/navigation/RegionToolbar"
import RegionHeader from "@/components/region/RegionHeader"
import BusinessSearch from "@/components/search/BusinessSearch"
import SearchResult from "@/components/search/v2/SearchResult"

import regionMeta from "@/mixins/regionMeta"
import currentYearMixin from "@/mixins/currentYearMixin"
import regionSearchRouting from "@/models/regionSearchRouting"

export default {
    components: {
        RegionToolbar,
        RegionHeader,
        BusinessSearch,
        SearchResult,
    },
    meta: {
        toolbar: {
            hideSearch: true,
        },
        footer: {
            showPowered: true,
        },
    },

    mixins: [currentYearMixin, regionMeta],
    watchQuery: true,
    async asyncData({ store, route, $axios }) {
        let categories = regionSearchRouting.getRouting(route)

        const response = await $axios.$get("/api/regions/" + route.params.slug)
        const region = response.data
        await store.dispatch("search/init", {
            categories: categories,
            selectedCategory: "Unternehmen",
            locationSlug: route.params.slug,
            query: route.query,
            channel: region.channel.slug,
            type: "region",
        })
        return {
            region: region,
        }
    },
    data: () => {
        return {
            region: {},
        }
    },
    head() {
        return {
            title:
                this.region.name +
                ": Top Ausbildungsbetriebe • Die besten Unternehmen",
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content:
                        this.region.name +
                        ": Entdecke für deine Ausbildung oder dein Prakikum die besten Firmen in der Region. Chatte direkt mit den Personalverantwortlichen der Betriebe!",
                },
                {
                    hid: "og:title",
                    name: "og:title",
                    content:
                        this.region.name +
                        ": Top Ausbildungsbetriebe • Die besten Unternehmen",
                },
                {
                    hid: "og:description",
                    name: "og:description",
                    content:
                        this.region.name +
                        ": Entdecke für deine Ausbildung oder dein Prakikum die besten Firmen in der Region. Chatte direkt mit den Personalverantwortlichen der Betriebe!",
                },
                ...this.getOgImage(),
            ],
        }
    },
}
